import { FC, useMemo, useState } from 'react'
import { UserAvatar, VideoPlayer } from 'src/components'
import { ICampaignModel } from 'src/interfaces'
import { getAvatar, getFirstCompanyRole, getFullName, StyleUtils, VideoUtils } from 'src/utils'
import Style from './style.module.scss'

interface IProps {
  campaign: Partial<ICampaignModel>
  autoPlayer?: boolean
}

export const CampaignVideoCard: FC<IProps> = ({ campaign, autoPlayer }) => {
  const video = useMemo(() => campaign.uploadVideo ?? campaign.author?.pfv, [campaign])
  const [showPreviewVideo, setShowPreviewVideo] = useState(false)

  return (
    <div
      className="w-full relative fx-ai-center fx-jc-center fx-row round-4 overflow-hidden z-0"
      onMouseEnter={() => autoPlayer && setShowPreviewVideo(true)}
      onMouseLeave={() => autoPlayer && setShowPreviewVideo(false)}
    >
      <div className="absolute b-7 z-3 w-full fx fx-ai-center fx-jc-space-between gap-4 px-4">
        <div className="fx fx-ai-center gap-4">
          {!!campaign.author && (
            <UserAvatar
              size={32}
              className="rounded"
              fullName={getFullName(campaign.author)}
              avatarUrl={getAvatar(campaign.author)}
            />
          )}
          <div className="fx-column gap-1">
            <div className="heading-16 txt-neutral-white three-dot-1">{getFullName(campaign.author)}</div>
            <div className="body-12 txt-neutral-white three-dot-1">{getFirstCompanyRole(campaign.author) || '--'}</div>
          </div>
        </div>
      </div>
      <div
        className={Style.videoPlayer}
        style={{
          aspectRatio: '9/16',
          ...StyleUtils.backgroundCover(video?.urlVideoImageThumbnail)
        }}
      >
        {(!autoPlayer || showPreviewVideo) && (
          <VideoPlayer
            autoplay={autoPlayer}
            hideStartEnd={autoPlayer}
            url={VideoUtils.getVideoSource(video)}
            tracks={video?.tracks}
            image={video?.urlVideoImageThumbnail}
          />
        )}
      </div>
    </div>
  )
}
